<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :viewBox="viewBox"
    :width="width"
    :height="height"
  >
    <path
      v-if="type === 'locked'"
      :fill="fillColor"
      path
      d="M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-104 0H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z"
    />
    <path
      v-else
      :fill="fillColor"
      d="M423.5 0C339.5.3 272 69.5 272 153.5V224H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48h-48v-71.1c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v80c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-80C576 68 507.5-.3 423.5 0z"
    />
  </svg>
</template>

<script>
import Base from "@/components/icons/Base";
export default {
  name: "LockIcon",
  extends: Base,
  props: {
    type: {
      type: String,
      default: "locked"
    }
  },
  computed: {
    viewBox() {
      return this.type === "locked" ? "0 0 448 512" : "0 0 576 512";
    }
  }
};
</script>
